import { useEffect, useState, useRef } from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Download, MenuBook, MoreVert, PictureAsPdf, Save } from '@mui/icons-material';
import { CircularProgress, ListItemIcon, ListSubheader, TextField } from '@mui/material';
import {

    Grid2 as Grid,
    DialogTitle,

} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DeleteconfirmationSection from '../DeleteConfirmationSection';
import { useEvent } from '../../context/eventContext';


const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function TemplateMenu({ load_listFn, saveAs, loadTemplate, label }) {
    const childRefDelete = useRef()
    const {selEvent} = useEvent()
    const [anchorEl, setAnchorEl] = useState(null);
    const [template_list, setTemplateList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [openDialog, setOpenDialog] = useState(false)
    const [templateName, setTemplateName] = useState('')
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setIsLoading(true)
        const res = load_listFn().then(r => {
            setTemplateList(r)
            setIsLoading(false)
        })
        if (res) {
            //setTemplateList(res)
        } else {

        }

        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setIsLoading(false)
    }, [template_list])

    const handleLoad = (t) => {

        const cb = async () => {
            if (selEvent.id) {
                loadTemplate(t)
            }
        }
        childRefDelete.current.confirmDelete('Carica Template', `Caricando il template: <b>${t.name}</b> sovrascriverai tutti gli elementi già presenti in questo  evento`, cb)
        handleClose()

    }

    const handleSave = () => {
        console.log("TRIGER SAVE")
        setTemplateName('')
        handleClose()
        setOpenDialog(true)
    }



    const handleCloseDialog = () => {
        setOpenDialog(false);
        handleClose()
    };


    const handleSaveDialog = () => {
        console.log("SAVE", templateName)
        saveAs(templateName)
        console.log("SSSS")
        setOpenDialog(false);
        handleClose()
    };
    return (
        <>
                <DeleteconfirmationSection ref={childRefDelete} />
            <Button
                id="template-button"
                aria-controls={open ? 'template-menu' : undefined}
                aria-haspopup="true"
                size="small"
                color="secondary"
                aria-expanded={open ? 'true' : undefined}
                variant={'contained'}
                disableElevation
                onClick={handleClick}
                startIcon={<MoreVert />}

            >
                {label}
            </Button>
            <StyledMenu
                id="template-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {saveAs &&
                    <MenuItem onClick={handleSave} disableRipple>
                    <ListItemIcon>
                        <Save />
                    </ListItemIcon>
                        Salva come template
                    </MenuItem>
                }
                <ListSubheader>lista template {isLoading && <CircularProgress size={20} />} </ListSubheader>
                {template_list.map((t, k) => (
                    <MenuItem key={k} onClick={() => handleLoad(t)} disableRipple>
                    <ListItemIcon>
                        <Download />
                    </ListItemIcon>
                        {t.name}
                    </MenuItem>
                ))}

            </StyledMenu>
            <Dialog open={openDialog} onClose={handleClose} fullWidth={true} maxWidth="sm">
                <DialogTitle>
                    Salvataggio template ({label})
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="award_name"
                        label={'Nome template'}
                        fullWidth
                        autoFocus={true}
                        value={templateName}
                        onChange={(el) => setTemplateName(el.target.value)}
                        name="award_name"
                        variant="standard"
                    />

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleCloseDialog}>Chiudi</Button>
                    <Button color="secondary" disabled={templateName.length===0} variant='contained' key={'sc'} onClick={handleSaveDialog} startIcon={<Save />}>Salva</Button>

                </DialogActions>
            </Dialog>
        </>
    );
}


